function Heart2Icon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9999 25.2589C13.6383 25.2589 13.2883 25.2122 12.9966 25.1072C8.53992 23.5789 1.45825 18.1539 1.45825 10.1389C1.45825 6.05552 4.75992 2.74219 8.81992 2.74219C10.7916 2.74219 12.6349 3.51219 13.9999 4.88885C15.3649 3.51219 17.2083 2.74219 19.1799 2.74219C23.2399 2.74219 26.5416 6.06719 26.5416 10.1389C26.5416 18.1655 19.4599 23.5789 15.0033 25.1072C14.7116 25.2122 14.3616 25.2589 13.9999 25.2589ZM8.81992 4.49219C5.72825 4.49219 3.20825 7.02385 3.20825 10.1389C3.20825 18.1072 10.8733 22.5405 13.5683 23.4622C13.7783 23.5322 14.2333 23.5322 14.4433 23.4622C17.1266 22.5405 24.8033 18.1189 24.8033 10.1389C24.8033 7.02385 22.2833 4.49219 19.1916 4.49219C17.4183 4.49219 15.7733 5.32052 14.7116 6.75552C14.3849 7.19885 13.6383 7.19885 13.3116 6.75552C12.2266 5.30885 10.5933 4.49219 8.81992 4.49219Z"
        fill="#657892"
      />
    </svg>
  );
}

export default Heart2Icon;
